import type { SiteType } from '@/app/types';

const deploySite = process.env.NEXT_PUBLIC_DEPLOY_SITE;

export const SITE: SiteType = deploySite === 'china' ? 'china' : 'global';
